
import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const images = [
    {
      url: 'https://readdy.ai/api/search-image?query=giant%20mainland%20leachianus%20gecko%20morph%20close%20up%20portrait%20showing%20unique%20coloration%20and%20patterns%20on%20simple%20clean%20background%20professional%20reptile%20photography&width=800&height=600&seq=gallery-morph-007&orientation=landscape',
      title: 'Giant Mainland',
      span: 'col-span-2 md:col-span-2 row-span-2'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=nuu%20ana%20leachianus%20gecko%20morph%20showing%20distinctive%20markings%20and%20colors%20close%20up%20detailed%20view%20simple%20background%20professional%20photography&width=400&height=400&seq=gallery-nuu-008&orientation=squarish',
      title: 'Nuu Ana',
      span: 'col-span-1 row-span-1'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=leachianus%20gecko%20climbing%20vertically%20on%20branch%20showing%20arboreal%20behavior%20side%20view%20simple%20background%20professional%20wildlife%20photography&width=400&height=600&seq=gallery-climb-009&orientation=portrait',
      title: 'Climbing Behavior',
      span: 'col-span-1 md:col-span-1 row-span-2'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=pink%20pastel%20leachianus%20gecko%20morph%20showing%20soft%20coloration%20close%20up%20portrait%20simple%20clean%20background%20professional%20reptile%20photography&width=400&height=400&seq=gallery-pink-010&orientation=squarish',
      title: 'Pink Morph',
      span: 'col-span-1 row-span-1'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=mint%20green%20leachianus%20gecko%20morph%20showing%20unique%20light%20coloration%20detailed%20close%20up%20simple%20background%20professional%20photography&width=600&height=400&seq=gallery-mint-011&orientation=landscape',
      title: 'Mint Green',
      span: 'col-span-2 row-span-1'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=gray%20leachianus%20gecko%20morph%20showing%20neutral%20coloration%20and%20texture%20close%20up%20portrait%20simple%20background%20professional%20reptile%20photography&width=400&height=400&seq=gallery-gray-012&orientation=squarish',
      title: 'Gray Morph',
      span: 'col-span-1 row-span-1'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=warm%20brown%20leachianus%20gecko%20morph%20showing%20rich%20earth%20tones%20detailed%20close%20up%20simple%20clean%20background%20professional%20photography&width=400&height=400&seq=gallery-brown-013&orientation=squarish',
      title: 'Brown Morph',
      span: 'col-span-1 row-span-1'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=leachianus%20gecko%20eye%20close%20up%20macro%20photography%20showing%20detailed%20iris%20and%20pupil%20structure%20simple%20background%20professional%20wildlife%20photography&width=600&height=400&seq=gallery-eye-014&orientation=landscape',
      title: 'Eye Detail',
      span: 'col-span-2 row-span-1'
    }
  ];

  return (
    <section id="gallery" className="py-16 md:py-32 px-4 md:px-8 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-4">Photo Gallery</h2>
          <p className="text-base md:text-lg text-gray-600">Explore the beauty and diversity of Leachianus morphs</p>
        </div>

        {/* Mobile: Simple 1-column grid */}
        <div className="grid grid-cols-1 gap-4 mb-8 md:hidden">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-xl cursor-pointer group aspect-[4/3]"
              onClick={() => setSelectedImage(index)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-lg font-semibold">{image.title}</h3>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-information-line text-white"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Tablet and Desktop: Complex grid layout */}
        <div className="hidden md:grid md:grid-cols-4 gap-4 mb-8 md:mb-12">
          {images.map((image, index) => (
            <div
              key={index}
              className={`${image.span} relative overflow-hidden rounded-xl cursor-pointer group`}
              onClick={() => setSelectedImage(index)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                  <h3 className="text-white text-lg md:text-xl font-semibold">{image.title}</h3>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-information-line text-white"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="border-2 border-[#B8E986] text-gray-900 px-6 md:px-10 py-3 md:py-4 rounded-lg text-sm md:text-base font-semibold hover:bg-[#B8E986] transition-all whitespace-nowrap cursor-pointer">
            View Full Collection
          </button>
        </div>
      </div>

      {selectedImage !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 md:p-8"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 md:top-8 right-4 md:right-8 text-white text-3xl md:text-4xl hover:text-[#B8E986] transition-colors w-10 md:w-12 h-10 md:h-12 flex items-center justify-center cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={images[selectedImage].url}
            alt={images[selectedImage].title}
            className="max-w-full max-h-full object-contain rounded-xl"
          />
          <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 text-center">
            <h3 className="text-white text-lg md:text-2xl font-semibold">{images[selectedImage].title}</h3>
          </div>
        </div>
      )}
    </section>
  );
}
